import { Button, CircularProgress, Divider, Grid } from "@material-ui/core";
import { useQuery } from "@tanstack/react-query";
import clsx from "clsx";
import { useState } from "react";
import { QuickwinCard } from "../../../components";
import type { Status } from "../../../models/gameplan";
import { useHistory } from "../../../shared/hooks/useHistory";
import { getQuickWinsList } from "../../services";
import { allQuickWinsListStyles } from "./all-quick-wins-list.styles";

const itemsToShow = 50;

type Props = {
  filteredBy?: Status.COMPLETED;
};

export const AllQuickWinsList = ({ filteredBy }: Props) => {
  const history = useHistory();
  const classes = allQuickWinsListStyles();
  const [pageSize, setPageSize] = useState(itemsToShow);
  const { data, isLoading } = useQuery({
    queryKey: ["quick-wins-list", pageSize, filteredBy],
    queryFn: () =>
      getQuickWinsList({
        pageNumber: 1,
        pageSize,
        keyword: filteredBy,
      }),
  });

  const loadMore = () => setPageSize((prevState) => prevState + itemsToShow);

  const loadMoreButtonDisabled = data?.totalRecords <= pageSize;

  return (
    <>
      <Divider />
      <Grid container spacing={3} className={classes.listContainer}>
        {data?.data.map((quickwin) => (
          <Grid
            item
            xs={6}
            md={4}
            key={quickwin.id}
            onClick={() => history.push("/learningPath")}
            className={clsx({
              [classes.clickableQuickWin]: quickwin.actionStep,
            })}
          >
            <QuickwinCard
              quickwin={quickwin}
              className={classes.quickwinCard}
            />
          </Grid>
        ))}
      </Grid>

      <div className={classes.loadMoreButtonContainer}>
        {isLoading && <CircularProgress />}
        <Button
          disabled={loadMoreButtonDisabled || isLoading}
          onClick={loadMore}
          className={classes.loadMoreButton}
        >
          Load More
        </Button>
      </div>
    </>
  );
};
